import React from 'react';
import { Tag, Tooltip } from 'antd';
import { Add, AddBox, Percent, SwapHoriz, TrendingUp } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Generic ExperimentTypePill component
 * Displays experiment type pills consistently across the application
 */
const ExperimentTypePill = ({ experimentType }) => {
  const { t } = useTranslation();

  if (!experimentType) return null;

  const getTypeConfig = () => {
    switch (experimentType) {
      case 'promo_combo_combinado':
        return {
          icon: <Add sx={{ fontSize: '12px' }} />,
          label: t('combo'),
          backgroundColor: '#fef2f2', // Warm red
          borderColor: '#fca5a5',
          textColor: '#991b1b'
        };
      case 'promo_precio_unitario':
        return {
          icon: <Percent sx={{ fontSize: '12px' }} />,
          label: t('discount'),
          backgroundColor: '#eff6ff', // Warm blue
          borderColor: '#bfdbfe',
          textColor: '#1e3a8a'
        };
      case 'reemplazo_producto':
        return {
          icon: <SwapHoriz sx={{ fontSize: '12px' }} />,
          label: t('reemplazo'),
          backgroundColor: '#fef3c7', // Warm amber/yellow
          borderColor: '#fcd34d',
          textColor: '#92400e'
        };
      case 'alza_precio_sugerido':
        return {
          icon: <TrendingUp sx={{ fontSize: '12px' }} />,
          label: t('priceIncrease'),
          backgroundColor: '#f0fdf4', // Warm green
          borderColor: '#bbf7d0',
          textColor: '#166534'
        };
      case 'ampliar_carril':
        return {
          icon: <AddBox sx={{ fontSize: '12px' }} />,
          label: t('laneExpansion'),
          backgroundColor: '#eef2ff', // Indigo
          borderColor: '#c7d2fe',
          textColor: '#3730a3'
        };
      default:
        return null;
    }
  };

  const config = getTypeConfig();
  if (!config) return null;

  return (
    <Tooltip 
      title={config.label} 
      placement="top" 
      mouseEnterDelay={0.2}
      overlayStyle={{
        fontSize: '12px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
      }}
    >
      <Tag
        color={config.backgroundColor}
        style={{
          color: config.textColor,
          borderColor: config.borderColor,
          fontSize: '11px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
          fontWeight: 500,
          textTransform: 'none',
          padding: '0 6px',
          margin: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '20px',
          width: '20px',
          borderRadius: '10px',
          cursor: 'help'
        }}
      >
        {React.cloneElement(config.icon, { 
          style: { fontSize: '12px' } 
        })}
      </Tag>
    </Tooltip>
  );
};

export default ExperimentTypePill;